import type { FormatCostCentsParams } from '../types';

const CENTS_PER_UNIT = 100;

const formatCostCents = ({ amountCents, currency }: FormatCostCentsParams): string =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency.toUpperCase(),
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amountCents / CENTS_PER_UNIT);

export default formatCostCents;
